import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";

import { fetchApi } from "@/helpers/fetchApi";

import { AppError } from "@/types";

type ReceiverEmailPreview = {
  subject: string;
  html: string;
};

type UseReceiverEmailPreviewProps = {
  language: string;
  walletName?: string;
};

// Fetches the receiver invitation email preview rendered by the backend so the UI
// always reflects exactly what receivers are sent (single source of truth).
export const useReceiverEmailPreview = ({
  language,
  walletName,
}: UseReceiverEmailPreviewProps) => {
  return useQuery<ReceiverEmailPreview, AppError>({
    queryKey: ["receiverEmailPreview", { language, walletName }],
    queryFn: async () => {
      const url = new URL(`${API_URL}/organization/email-preview`);
      url.searchParams.set("language", language || "en");

      if (walletName) {
        url.searchParams.set("wallet", walletName);
      }

      return await fetchApi(url.toString());
    },
    enabled: Boolean(language),
  });
};
